import { gql } from "@apollo/client";

export const deleteTier = gql`
  mutation DeleteTier($id: ID!) {
    deleteTier(id: $id)
  }
`;
